import { render, staticRenderFns } from "./MasterStart.vue?vue&type=template&id=595d77e6&scoped=true&"
import script from "./MasterStart.vue?vue&type=script&lang=js&"
export * from "./MasterStart.vue?vue&type=script&lang=js&"
import style0 from "./MasterStart.vue?vue&type=style&index=0&id=595d77e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595d77e6",
  null
  
)

export default component.exports